import { Link } from '@tanstack/react-router';

import { PageHeading } from '../ui/PageHeading';

export function NotFoundPage() {
  return (
    <>
      <PageHeading>Page not found</PageHeading>
      <p>There&apos;s no page at this address.</p>
      <p className="mt-6">
        <Link to="/">Go to the home page</Link>
      </p>
    </>
  );
}
